import { apiSlice } from "../stores/base/api-slice";

const serviceBaseurl = "/product/company/"

interface CompanyInfoResponse {
    id: string;
    name: string;
    businessInfo: string | null;
    businessType: string;
    rcNumber: string;
    address: string;
    state: string;
    city: string;
    firstLogin: boolean;
    country: string;
}

const companyEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCompanyInfo: builder.query<CompanyInfoResponse, { companyId: string}>({
            query: (companyId) => ({
                url: `${serviceBaseurl}get-company-info`,
                method: "GET",
                params: companyId,
            }),
        }),
        getCompanyFirstTimeLoginStatus: builder.query<any, void>({
            query: () => ({
                url: `${serviceBaseurl}login-status`,
                method: "GET",
            }),
        }),
    }),
});

export const { useLazyGetCompanyInfoQuery, useLazyGetCompanyFirstTimeLoginStatusQuery } = companyEndpoints;
